// --------------------- Import React ---------------------
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

// --------------------- Import Hooks ---------------------
import { useCotaUsuario } from "../hooks/useCotaUsuario";
import { useCidade } from "../hooks/useCidade";
import { useBuscarPaises } from "../hooks/useBuscarPaisesService";
import { useUsuario } from "../hooks/useUsuario";
import { useEndereco } from "../hooks/useEndereco";
import { useEstado } from "../hooks/useEstado";
import { useRepresentante } from "../hooks/useRepresentante";
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";
// --------------------- Import Styles ---------------------
import {
  ContainerModal,
  TitleModal,
  TextModal,
  formStyle,
  ContainerModalBtn,
  btnStyle,
  AlertTextModal,
  ContainerModalArquivo,
} from "../styles";
// --------------------- Import Utils ---------------------
import { filterOption, filterSort } from "../utils/filtroSelect";
// --------------------- Import Antd-Design ---------------------
import {
  Modal,
  Skeleton,
  Form,
  Input,
  Select,
  Flex,
  List,
  Button,
  Upload,
  UploadProps,
} from "antd";
// --------------------- Import Interfaces ---------------------

import { ValidacaoProprietario } from "../interfaces/ValidacaoProprietario";
import { IModal } from "../interfaces/Modal";

// --------------------- Import Constants ---------------------
import { estadoCivil } from "../constant/estadoCivilOptions";
import { UploadOutlined } from "@ant-design/icons";
import { useArquivos } from "../hooks/useArquivos";
import { useAtualizarDadosValidacaoProprietario } from "../hooks/useAtualizarDadosValidacaoProprietario";
import { useFileUpload } from "../hooks/useUploadFiles";
import { layout } from "../constant/layout";

export default function ModalValidacaoProprietario({
  isModalOpen,
  handleFechar,
  cotaUsuarioId,
}: IModal) {
  // Define o nome do  formulario
  const [formAtualizarCadastro] = Form.useForm();
  const [formAtualizarRepresentante] = Form.useForm();

  const [selectedEstado, setSelectedEstado] = useState<number>();

  // Referencia de edição
  const changing = useRef<boolean>(false);

  // Use para buscar as info de Cota Usuário
  const { cotaUsuario } = useCotaUsuario(cotaUsuarioId, isModalOpen);

  // Use para buscar os Países
  const { paises } = useBuscarPaises(isModalOpen);

  // Use para buscar os Estados
  const { estados } = useEstado(isModalOpen);

  // Use para buscar as Cidades
  const { cidades } = useCidade(isModalOpen, selectedEstado);

  // Use para buscar os dados do Usuário Logado
  const { isLoading: isLoadingUsuario, usuario } = useUsuario(
    cotaUsuario?.usuarioId,
    isModalOpen
  );

  // Use para buscar os dados do Usuário Logado
  const { isLoading: isLoadingEndereco, endereco } = useEndereco(
    cotaUsuario?.usuarioId,
    isModalOpen
  );

  // Use para saber se há representante
  const { representante } = useRepresentante(cotaUsuarioId, isModalOpen);

  // Use para buscar os dados do Representante
  const { usuario: usuarioRepresentante } = useUsuario(
    representante?.usuarioId,
    isModalOpen
  );

  // Use para buscar os dados do endereço do representante
  const { endereco: enderecoRepresentante } = useEndereco(
    representante?.usuarioId,
    isModalOpen
  );

  // Use para buscar os arquivos da propriedade
  const { arquivos } = useArquivos(cotaUsuarioId, isModalOpen);

  // Estado inicial formulário de Validação Proprietario Atualizar Usuario
  const [
    validacaoProprietarioAtualizarUsuario,
    setValidacaoProprietarioAtualizarUsuario,
  ] = useState<ValidacaoProprietario>({});

  // Estado inicial formulário de Validação Proprietario Atualizar Representante
  const [
    validacaoProprietarioAtualizarRepresentante,
    setValidacaoProprietarioAtualizarRepresentante,
  ] = useState<ValidacaoProprietario>({});

  // Estado inicial  Atualizar cadastro Usuario
  const [atualizarUsuario, setAtualizarUsuario] =
    useState<ValidacaoProprietario>({});

  // Estado inicial  Atualizar endereço Usuario
  const [atualizarEnderecoUsuario, setAtualizarEnderecoUsuario] =
    useState<ValidacaoProprietario>({});

  // Estado inicial  Atualizar Representante
  const [atualizarRepresentante, setAtualizarRepresentante] =
    useState<ValidacaoProprietario>({});

  // Estado inicial  Atualizar endereço Representante
  const [atualizarEnderecoRepresentante, setAtualizarEnderecoRepresentante] =
    useState<ValidacaoProprietario>({});
  // Atualiza o estado do formulário somente quando todos os dados estiverem disponíveis
  useEffect(() => {
    if (isModalOpen) {
      setValidacaoProprietarioAtualizarUsuario({
        nome: usuario?.nome,
        sobrenome: usuario?.sobrenome,
        nacionalidade: usuario?.nacionalidade,
        estadoCivil: usuario?.estadoCivil,
        cpf: usuario?.cpf,
        endereco: endereco?.endereco,
        complemento: endereco?.complemento,
        estadoId: endereco?.estadoId,
        cidadeId: endereco?.cidadeId,
      });
      setValidacaoProprietarioAtualizarRepresentante({
        nome: usuarioRepresentante?.nome,
        sobrenome: usuarioRepresentante?.sobrenome,
        cpf: usuarioRepresentante?.cpf,
        email: usuarioRepresentante?.email,
        celular: usuarioRepresentante?.celular,
        nacionalidade: usuarioRepresentante?.nacionalidade,
        estadoCivil: usuarioRepresentante?.estadoCivil,
        endereco: enderecoRepresentante?.endereco,
        complemento: enderecoRepresentante?.complemento,
        estadoId: enderecoRepresentante?.estadoId,
        cidadeId: enderecoRepresentante?.cidadeId,
      });
    }
  }, [
    isModalOpen,
    endereco,
    usuario,
    usuarioRepresentante,
    enderecoRepresentante,
  ]); // Dependências: isModalOpen,  endereco, usuario,usuarioRepresentante,enderecoRepresentante

  useEffect(() => {
    if (
      validacaoProprietarioAtualizarUsuario &&
      validacaoProprietarioAtualizarRepresentante
    ) {
      formAtualizarCadastro.setFieldsValue({
        nome: validacaoProprietarioAtualizarUsuario?.nome,
        sobrenome: validacaoProprietarioAtualizarUsuario?.sobrenome,
        nacionalidade: validacaoProprietarioAtualizarUsuario?.nacionalidade,
        estadoCivil: validacaoProprietarioAtualizarUsuario?.estadoCivil,
        cpf: validacaoProprietarioAtualizarUsuario?.cpf,
        endereco: validacaoProprietarioAtualizarUsuario?.endereco,
        complemento: validacaoProprietarioAtualizarUsuario?.complemento,
        estadoId: validacaoProprietarioAtualizarUsuario?.estadoId,
        cidadeId: validacaoProprietarioAtualizarUsuario?.cidadeId,
      });

      formAtualizarRepresentante.setFieldsValue({
        nome: validacaoProprietarioAtualizarRepresentante?.nome,
        sobrenome: validacaoProprietarioAtualizarRepresentante?.sobrenome,
        cpf: validacaoProprietarioAtualizarRepresentante?.cpf,
        email: validacaoProprietarioAtualizarRepresentante?.email,
        celular: validacaoProprietarioAtualizarRepresentante?.celular,
        nacionalidade:
          validacaoProprietarioAtualizarRepresentante?.nacionalidade,
        estadoCivil: validacaoProprietarioAtualizarRepresentante?.estadoCivil,
        endereco: validacaoProprietarioAtualizarRepresentante?.endereco,
        complemento: validacaoProprietarioAtualizarRepresentante?.complemento,
        estadoId: validacaoProprietarioAtualizarRepresentante?.estadoId,
        cidadeId: validacaoProprietarioAtualizarRepresentante?.cidadeId,
      });
    }
  }, [
    formAtualizarCadastro,
    formAtualizarRepresentante,
    validacaoProprietarioAtualizarUsuario,
    validacaoProprietarioAtualizarRepresentante,
  ]); // Atualiza quando cadastroInicial mudar

  //Função que armazena no state o estado selecionado
  const handleEstadoChange = (value: number, formAtualizar: any) => {
    changing.current = true;

    setSelectedEstado(value);

    formAtualizar.setFieldsValue({ cidadeId: undefined }); // Limpa o valor da cidade no formulário específico
  };
  // Função que armazena os dados alterados de atualizar cadastro
  const atualizarCadastroChange = (
    changedValues: Partial<any>,
    allValues: any
  ) => {
    changing.current = true;
    if (changing.current) {
      setAtualizarUsuario({
        nome: allValues.nome,
        sobrenome: allValues.sobrenome,
        estadoCivil: allValues.estadoCivil,
      });
      setAtualizarEnderecoUsuario({
        endereco: allValues.endereco,
        complemento: allValues.complemento,
        cidadeId: allValues.cidadeId,
        estadoId: allValues.estadoId,
      });
    }
  };

  const cadastrarProprietarioChange = (
    changedValues: Partial<any>,
    allValues: any
  ) => {
    changing.current = true;

    if (changing.current) {
      setAtualizarRepresentante((prevState) => ({
        ...prevState, // Espalha o estado anterior
        ...allValues, // Espalha os novos valores (allValues)
      }));

      setAtualizarEnderecoRepresentante((prevState) => ({
        ...prevState, // Espalha o estado anterior
        ...allValues, // Espalha os novos valores (allValues)
      }));
    }
  };

  // Função que armazena o id do pais selecionado para a atualização de cadastro e cadastro do proprietario
  const paisChange = (value: any, formAtualizar: any) => {
    // Encontrar o país correspondente ao valor selecionado
    const paisSelecionado = paises.find((pais) => pais.abreviacao === value);

    // Verificar se encontrou o país
    if (paisSelecionado) {
      changing.current = true;
      if (formAtualizar === "formAtualizarCadastro") {
        setAtualizarUsuario((usuarioState) => ({
          ...usuarioState,
          paisId: paisSelecionado.id,
        }));
        setAtualizarEnderecoUsuario((enderecoUsuarioState) => ({
          ...enderecoUsuarioState,
          paisId: paisSelecionado.id,
        }));
      }
      if (formAtualizar === "formAtualizarRepresentante") {
        setAtualizarRepresentante((represanteState) => ({
          ...represanteState,
          paisId: paisSelecionado.id,
        }));
        setAtualizarEnderecoRepresentante((represanteEnderecoState) => ({
          ...represanteEnderecoState,
          paisId: paisSelecionado.id,
        }));
      }
    }
  };

  // Função que realiza o Upload de arquivos

  // Usando o hook
  const {
    fileList,
    uploading,
    handleRemove,
    beforeUpload,
    handleUpload,
    error: arquivoError,
    success: arquivoSuccess,
  } = useFileUpload(cotaUsuarioId);

  const props: UploadProps = {
    onRemove: handleRemove,
    beforeUpload,
    fileList,
  };

  // Função que atualiza os dados
  const { atualizarDadosValidacaoProprietario, error, success } =
    useAtualizarDadosValidacaoProprietario();

  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Sucesso
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Hook de navegação do React Router
  const navigate = useNavigate();

  const errorRef = useRef<string | null>("");
  // Atualiza o valor de errorRef  toda vez que o error e warning mudar
  useEffect(() => {
    if (error) {
      errorRef.current = error;
    }
  }, [error]);
  // useEffect para lidar com as mensagens
  useEffect(() => {
    if (isModalOpen) {
      if (success && !successDisplayed) {
        // Verifica se o sucesso já foi exibido
        showSuccess(success);
        setSuccessDisplayed(true);
        setTimeout(() => {
          navigate(0); // Use navigate(0) para simular um refresh completo
        }, 3000);
      }
      if (errorRef.current && !errorDisplayed) {
        // Verifica se o erro já foi exibido
        showError(errorRef.current);
        setErrorDisplayed(true); // Marca que o erro foi exibido

        // Limpa estado de error após 3 segundos
        setTimeout(() => {
          setErrorDisplayed(false);
          errorRef.current = null;
        }, 3000);
      }
    }

    // Limpa o estado de sucesso quando o modal é fechado
    if (!isModalOpen) {
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    showSuccess,
    successDisplayed,
    errorDisplayed,
    showError,
    navigate,
  ]);

  // Sucesso de envio de arquivo
  // Estado para controlar se o erro já foi exibido
  const [arquivoErrorDisplayed, setArquivoErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [arquivoSuccessDisplayed, setArquivoSuccessDisplayed] = useState(false);
  useEffect(() => {
    if (isModalOpen && arquivoSuccess && !arquivoSuccessDisplayed) {
      // Verifica se o sucesso já foi exibido
      showSuccess(arquivoSuccess);
      setArquivoSuccessDisplayed(true);
      setTimeout(() => {
        navigate(0); // Use navigate(0) para simular um refresh completo
      }, 1000);
    }

    // Limpa o estado de sucesso quando o modal é fechado
    if (!isModalOpen) {
      setSuccessDisplayed(false);
    }
  }, [
    isModalOpen,
    arquivoSuccess,
    showSuccess,
    arquivoSuccessDisplayed,
    navigate,
  ]);

  // useEffect para lidar com o erro
  useEffect(() => {
    if (isModalOpen && arquivoError && !arquivoErrorDisplayed) {
      // Verifica se o erro já foi exibido
      showError(arquivoError);
      setArquivoErrorDisplayed(true); // Marca que o erro foi exibido
    }

    // Limpa o estado de erro quando o modal é fechado
    if (!isModalOpen) {
      setArquivoErrorDisplayed(false); // Reseta o controle de erro
    }
  }, [isModalOpen, arquivoError, showError, arquivoErrorDisplayed, navigate]);

  return (
    <Modal open={isModalOpen} onCancel={handleFechar} footer={null}>
      {isLoadingUsuario && isLoadingEndereco && <Skeleton active />}
      {!isLoadingUsuario && usuario && !isLoadingEndereco && (
        <>
          {" "}
          <ContainerModal>
            {/* Exibe a mensagem de erro */}
            <div key="error-message-holder">{errorContextHolder}</div>
            <div key="success-message-holder">{successContextHolder}</div>
            <TitleModal>Validação de Proprietario</TitleModal>
            {/* Atualizar cadastro usuário */}
            <Form
              {...layout}
              form={formAtualizarCadastro}
              name="atualizar-cadastro"
              onValuesChange={(changedValues, allValues) =>
                atualizarCadastroChange(changedValues, allValues)
              }
              initialValues={validacaoProprietarioAtualizarUsuario}
              style={formStyle}
            >
              <TextModal>Atualizar Dados Proprietário</TextModal>
              <Form.Item name={["nome"]} label="Nome" className="formItems">
                <Input />
              </Form.Item>
              <Form.Item
                name={["sobrenome"]}
                label="Sobrenome"
                className="formItems"
              >
                <Input />
              </Form.Item>
              <Form.Item
                name={["nacionalidade"]}
                label="Nacionalidade"
                className="formItems"
              >
                <Select
                  onChange={(value) =>
                    paisChange(value, "formAtualizarCadastro")
                  }
                  placeholder="Selecione a nacionalidade"
                >
                  {paises.map((pais) => (
                    <Select.Option key={pais.id} value={pais.abreviacao}>
                      {pais.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name={["estadoCivil"]}
                label="Estado Civil"
                className="formItems"
              >
                <Select>
                  {estadoCivil.map((ec, index) => (
                    <Select.Option key={ec.id} value={ec.value}>
                      {ec.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name={["cpf"]} label="CPF" className="formItems">
                <Input />
              </Form.Item>
              <Form.Item
                name={["endereco"]}
                label="Endereço"
                className="formItems"
              >
                <Input />
              </Form.Item>
              <Form.Item
                name={["complemento"]}
                label="Complemento"
                className="formItems"
              >
                <Input />
              </Form.Item>

              <Form.Item
                name={["estadoId"]}
                label="Estado"
                className="formItems"
              >
                <Select
                  showSearch
                  placeholder="Selecione o estado"
                  onChange={(value) =>
                    handleEstadoChange(value, formAtualizarCadastro)
                  }
                  filterOption={filterOption}
                  filterSort={filterSort}
                >
                  {estados.map((estado) => (
                    <Select.Option
                      key={estado.id}
                      value={estado.id}
                      label={estado.nome}
                    >
                      {estado.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name={["cidadeId"]}
                label="Cidade"
                className="formItems"
              >
                <Select
                  showSearch
                  placeholder="Selecione a cidade"
                  optionFilterProp="children"
                >
                  {cidades.map((cidade) => (
                    <Select.Option
                      key={cidade.id}
                      value={cidade.id}
                      label={cidade.nome}
                    >
                      {cidade.nome}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Form>

            {/* Atualizar cadastro representante */}
            {/* Verifica se há representante, só ira ser exibido se houver um  */}
            {representante ? (
              <Form
                {...layout}
                form={formAtualizarRepresentante}
                name="dados-proprietario"
                onValuesChange={(changedValues, allValues) =>
                  cadastrarProprietarioChange(changedValues, allValues)
                }
                initialValues={validacaoProprietarioAtualizarRepresentante}
                style={formStyle}
              >
                <TextModal>Atualizar Representante</TextModal>
                <Form.Item name={["nome"]} label="Nome" className="formItems">
                  <Input />
                </Form.Item>
                <Form.Item
                  name={["sobrenome"]}
                  label="Sobrenome"
                  className="formItems"
                >
                  <Input />
                </Form.Item>
                <Form.Item name={["cpf"]} label="CPF" className="formItems">
                  <Input />
                </Form.Item>
                <Form.Item
                  name={["email"]}
                  label="E-mail"
                  className="formItems"
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name={["celular"]}
                  label="Celular"
                  className="formItems"
                >
                  <Input placeholder="(00) 00000-0000" />
                </Form.Item>
                <Form.Item
                  name={["nacionalidade"]}
                  label="Nacionalidade"
                  className="formItems"
                >
                  <Select
                    onChange={(value) =>
                      paisChange(value, "formAtualizarRepresentante")
                    }
                    placeholder="Selecione a nacionalidade"
                  >
                    {paises.map((pais) => (
                      <Select.Option key={pais.id} value={pais.abreviacao}>
                        {pais.nome}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name={["estadoCivil"]}
                  label="Estado Civil"
                  className="formItems"
                >
                  <Select>
                    {estadoCivil.map((ec, index) => (
                      <Select.Option key={ec.id} value={ec.value}>
                        {ec.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name={["endereco"]}
                  label="Endereço"
                  className="formItems"
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name={["complemento"]}
                  label="Complemento"
                  className="formItems"
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  name={["estadoId"]}
                  label="Estado"
                  className="formItems"
                >
                  <Select
                    showSearch
                    placeholder="Selecione o estado"
                    onChange={(value) =>
                      handleEstadoChange(value, formAtualizarRepresentante)
                    }
                    filterOption={filterOption}
                    filterSort={filterSort}
                  >
                    {estados.map((estado) => (
                      <Select.Option
                        key={estado.id}
                        value={estado.id}
                        label={estado.nome}
                      >
                        {estado.nome}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name={["cidadeId"]}
                  label="Cidade"
                  className="formItems"
                >
                  <Select
                    showSearch
                    placeholder="Selecione a cidade"
                    optionFilterProp="children"
                    filterOption={filterOption}
                    filterSort={filterSort}
                  >
                    {cidades.map((c) => (
                      <Select.Option key={c.id} value={c.id} label={c.nome}>
                        {c.nome}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Form>
            ) : (
              <>
                <AlertTextModal>
                  Essa propriedade não possuí representante
                </AlertTextModal>
              </>
            )}

            <ContainerModalArquivo>
              <TextModal>Atualizar Arquivos</TextModal>
              <Upload {...props}>
                <Button icon={<UploadOutlined />}>
                  Clique para carregar arquivo
                </Button>
              </Upload>

              <Flex align="center" justify="center">
                <Button
                  type="primary"
                  onClick={handleUpload}
                  loading={uploading}
                  style={btnStyle}
                  size="large"
                >
                  {uploading ? "Uploading" : "Anexar"}
                </Button>
              </Flex>

              {arquivos.length > 0 && (
                <List
                  style={{ marginTop: 20 }}
                  header={<div>Arquivos Carregados</div>}
                  bordered
                  dataSource={arquivos}
                  renderItem={(item: any) => (
                    <List.Item>
                      <a
                        href={item.ArquivoTable.path}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.ArquivoTable.originalname}
                      </a>
                    </List.Item>
                  )}
                />
              )}
            </ContainerModalArquivo>
          </ContainerModal>
          <ContainerModalBtn>
            {/* Botão para atualizar os dados */}
            <Button
              type="primary"
              onClick={() =>
                atualizarDadosValidacaoProprietario(
                  cotaUsuario?.usuarioId,
                  atualizarUsuario,
                  endereco?.id || 0,
                  atualizarEnderecoUsuario,
                  representante?.usuarioId,
                  atualizarRepresentante,
                  enderecoRepresentante?.id || 0,
                  atualizarEnderecoRepresentante
                )
              }
              style={btnStyle}
              size="large"
            >
              Atualizar
            </Button>
          </ContainerModalBtn>
        </>
      )}
    </Modal>
  );
}
